define('config/routeTranslations',{
    'games': { sv: 'spel', fi: 'pelit', no: 'spillvelger', de: 'spiele'},
    'play': { sv: 'spela', fi: 'pelaa', no: 'spill', de: 'spielen'},
    'about-casumo': { sv: 'om-casumo', fi: 'casumosta', no: 'om-casumo', de: 'ueber-casumo'},
    'classics': {
        sv: 'klassiskt-casino',
        fi: 'klassinen-casino',
        no: 'klassisk-casino',
        en: 'classic-casino',
        de: 'klassisches-casino'
    },
    'other': {
        sv: 'andra-spela',
        fi: 'muut-pelit',
        no: 'andre-spill',
        en: 'other-games',
        de: 'andere-spiele'
    },
    'slots': { no: 'spilleautomater', fi: 'kolikkopelit', de: 'spielautomaten'}
});

